import { fromJS } from 'immutable';
export var SET_STATS_ZONES = 'stats-dashboard/SET_STATS_ZONES';
export var SET_STATS_GATES_FOR_PIE = 'stats-dashboard/SET_STATS_GATES_FOR_PIE';
export var SET_STATS_GATES_FOR_XY = 'stats-dashboard/SET_STATS_GATES_FOR_XY';
export var SET_STATS_GATES_PIE_SELECTED = 'stats-dashboard/SET_STATS_GATES_PIE_SELECTED';
export var SET_STATS_GATES_XY_SELECTED = 'stats-dashboard/SET_STATS_GATES_XY_SELECTED'; // export const SET_STATS_TERMINALS = 'stats-dashboard/SET_STATS_TERMINALS'

export var SET_STATS_TERMINALS_FOR_PIE = 'stats-dashboard/SET_STATS_TERMINALS_FOR_PIE';
export var SET_STATS_TERMINALS_FOR_XY = 'stats-dashboard/SET_STATS_TERMINALS_FOR_XY';
export var SET_STATS_TERMINALS_DELIVERY = 'stats-dashboard/SET_STATS_TERMINALS_DELIVERY';
export var SET_STATS_TERMINALS_PIE_SELECTED = 'stats-dashboard/SET_STATS_TERMINALS_PIE_SELECTED';
export var SET_STATS_TERMINALS_XY_SELECTED = 'stats-dashboard/SET_STATS_TERMINALS_XY_SELECTED';
export var SET_TERMINALSXY_ZONES_SELECTED = 'stats-dashboard/SET_TERMINALSXY_ZONES_SELECTED';
export var SET_TERMINALSXY_TERMINALS_SELECTED = 'stats-dashboard/SET_TERMINALSXY_TERMINALS_SELECTED';
export var SET_LOGS_GATES = 'stats-dashboard/SET_LOGS_GATES';
export var SET_LOGS_GATES_SELECTED = 'stats-dashboard/SET_LOGS_GATES_SELECTED';
export var SET_GATES_SORT = 'stats-dashboard/SET_GATES_SORT';
export var SET_LOGS_GATES_ROW_PER_PAGE = 'stats-dashboard/SET_LOGS_GATES_ROW_PER_PAGE';
export var SET_LOGS_GATES_CURRENT_PAGE = 'stats-dashboard/SET_LOGS_GATES_CURRENT_PAGE';
export var SET_LOGS_GATES_TOTAL = 'stats-dashboard/SET_LOGS_GATES_TOTAL';
export var SET_LOGS_TERMINALS = 'stats-dashboard/SET_LOGS_TERMINALS';
export var SET_LOGS_TERMINALS_SELECTED = 'stats-dashboard/SET_LOGS_TERMINALS_SELECTED';
export var SET_TERMINALS_SORT = 'stats-dashboard/SET_TERMINALS_SORT';
export var SET_LOGS_TERMINALS_ROW_PER_PAGE = 'stats-dashboard/SET_LOGS_TERMINALS_ROW_PER_PAGE';
export var SET_LOGS_TERMINALS_CURRENT_PAGE = 'stats-dashboard/SET_LOGS_TERMINALS_CURRENT_PAGE';
export var SET_LOGS_TERMINALS_TOTAL = 'stats-dashboard/SET_LOGS_TERMINALS_TOTAL';
export var SET_ZONESLIST = 'stats-dashboard/SET_ZONESLIST';
export var SET_TERMINALSLIST = 'stats-dashboard/SET_TERMINALSLIST';
export var SET_DATETIME = 'stats-dashboard/SET_DATETIME';
export var SET_IS_DATETIME_CHANGE = 'state-dashboard/SET_IS_DATETIME_CHANGE';
export var RESET = 'state-dashboard/RESET';
export var setStatsZones = function setStatsZones(data) {
  return {
    type: SET_STATS_ZONES,
    data: data
  };
};
export var setStatsGatesForPie = function setStatsGatesForPie(data) {
  return {
    type: SET_STATS_GATES_FOR_PIE,
    data: data
  };
};
export var setStatsGatesForXY = function setStatsGatesForXY(data) {
  return {
    type: SET_STATS_GATES_FOR_XY,
    data: data
  };
};
export var setStatsGatesPieSelected = function setStatsGatesPieSelected(data) {
  return {
    type: SET_STATS_GATES_PIE_SELECTED,
    data: data
  };
};
export var setStatsGatesXYSelected = function setStatsGatesXYSelected(data) {
  return {
    type: SET_STATS_GATES_XY_SELECTED,
    data: data
  };
}; // export const setStatsTerminals = data => ({
//     type: SET_STATS_TERMINALS,
//     data: data
// })

export var setStatsTerminalsForPie = function setStatsTerminalsForPie(data) {
  return {
    type: SET_STATS_TERMINALS_FOR_PIE,
    data: data
  };
};
export var setStatsTerminalsForXY = function setStatsTerminalsForXY(data) {
  return {
    type: SET_STATS_TERMINALS_FOR_XY,
    data: data
  };
};
export var setStatsTerminalsDelivery = function setStatsTerminalsDelivery(data) {
  return {
    type: SET_STATS_TERMINALS_DELIVERY,
    data: data
  };
};
export var setStatsTerminalsPieSelected = function setStatsTerminalsPieSelected(data) {
  return {
    type: SET_STATS_TERMINALS_PIE_SELECTED,
    data: data
  };
};
export var setStatsTerminalsXYSelected = function setStatsTerminalsXYSelected(data) {
  return {
    type: SET_STATS_TERMINALS_XY_SELECTED,
    data: data
  };
};
export var setTerminalsXYZonesSelected = function setTerminalsXYZonesSelected(data) {
  return {
    type: SET_TERMINALSXY_ZONES_SELECTED,
    data: data
  };
};
export var setTerminalsXYTerminalsSelected = function setTerminalsXYTerminalsSelected(data) {
  return {
    type: SET_TERMINALSXY_TERMINALS_SELECTED,
    data: data
  };
}; //gates

export var setLogsGates = function setLogsGates(data) {
  return {
    type: SET_LOGS_GATES,
    data: data
  };
};
export var setLogsGatesSelected = function setLogsGatesSelected(data) {
  return {
    type: SET_LOGS_GATES_SELECTED,
    data: data
  };
};
export var setGatesSort = function setGatesSort(sort) {
  return {
    type: SET_GATES_SORT,
    sort: sort
  };
};
export var setLogsGatesRowPerPage = function setLogsGatesRowPerPage(data) {
  return {
    type: SET_LOGS_GATES_ROW_PER_PAGE,
    data: data
  };
};
export var setLogsGatesCurrentPage = function setLogsGatesCurrentPage(data) {
  return {
    type: SET_LOGS_GATES_CURRENT_PAGE,
    data: data
  };
};
export var setLogsGatesTotal = function setLogsGatesTotal(data) {
  return {
    type: SET_LOGS_GATES_TOTAL,
    data: data
  };
}; // terminals

export var setLogsTerminals = function setLogsTerminals(data) {
  return {
    type: SET_LOGS_TERMINALS,
    data: data
  };
};
export var setLogsTerminalsSelected = function setLogsTerminalsSelected(data) {
  return {
    type: SET_LOGS_TERMINALS_SELECTED,
    data: data
  };
};
export var setTerminalsSort = function setTerminalsSort(sort) {
  return {
    type: SET_TERMINALS_SORT,
    sort: sort
  };
};
export var setLogsTerminalsRowPerPage = function setLogsTerminalsRowPerPage(data) {
  return {
    type: SET_LOGS_TERMINALS_ROW_PER_PAGE,
    data: data
  };
};
export var setLogsTerminalsCurrentPage = function setLogsTerminalsCurrentPage(data) {
  return {
    type: SET_LOGS_TERMINALS_CURRENT_PAGE,
    data: data
  };
};
export var setLogsTerminalsTotal = function setLogsTerminalsTotal(data) {
  return {
    type: SET_LOGS_TERMINALS_TOTAL,
    data: data
  };
};
export var setZonesList = function setZonesList(data) {
  return {
    type: SET_ZONESLIST,
    data: data
  };
};
export var setTerminalsList = function setTerminalsList(data) {
  return {
    type: SET_TERMINALSLIST,
    data: data
  };
};
export var setDateTime = function setDateTime(data) {
  return {
    type: SET_DATETIME,
    data: data
  };
};
export var setIsDateTimeChange = function setIsDateTimeChange(data) {
  return {
    type: SET_IS_DATETIME_CHANGE,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  statsZones: [],
  statsGatesForPie: [],
  statsGatesForXY: [],
  statsGatesPieSelected: '',
  statsGatesXYSelected: '',
  // statsTerminals: [],
  statsTerminalsForPie: [],
  statsTerminalsForXY: [],
  statsTerminalsDelivery: [],
  statsTerminalsPieSelected: '',
  statsTerminalsXYSelected: '',
  terminalsXYZonesSelected: '',
  terminalsXYTerminalsSelected: '',
  logsGates: [],
  logsGatesSelected: '',
  gatesSort: {
    field: 'passTime',
    desc: false
  },
  logsGatesRowsPerPage: 10,
  logsGatesCurrentPage: 0,
  logsGatesTotal: 0,
  logsTerminals: [],
  logsTerminalsSelected: '',
  terminalsSort: {
    field: 'entryTime',
    desc: false
  },
  logsTerminalsRowsPerPage: 10,
  logsTerminalsCurrentPage: 0,
  logsTerminalsTotal: 0,
  // dropdown list
  zonesList: [],
  terminalsList: [],
  // date time format: 'YYYY/MM/DD HH:MM:ss'
  dateTime: {
    from: '',
    to: ''
  },
  isDateTimeChange: true
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_STATS_ZONES:
      return state.set('statsZones', action.data);

    case SET_STATS_GATES_FOR_PIE:
      return state.set('statsGatesForPie', action.data);

    case SET_STATS_GATES_FOR_XY:
      return state.set('statsGatesForXY', action.data);

    case SET_STATS_GATES_PIE_SELECTED:
      return state.set('statsGatesPieSelected', action.data);

    case SET_STATS_GATES_XY_SELECTED:
      return state.set('statsGatesXYSelected', action.data);

    case SET_TERMINALSXY_ZONES_SELECTED:
      return state.set('terminalsXYZonesSelected', action.data);

    case SET_TERMINALSXY_TERMINALS_SELECTED:
      return state.set('terminalsXYTerminalsSelected', action.data);
    // case SET_STATS_TERMINALS:
    //     return state.set('statsTerminals', action.data)

    case SET_STATS_TERMINALS_FOR_PIE:
      return state.set('statsTerminalsForPie', action.data);

    case SET_STATS_TERMINALS_FOR_XY:
      return state.set('statsTerminalsForXY', action.data);

    case SET_STATS_TERMINALS_DELIVERY:
      return state.set('statsTerminalsDelivery', action.data);

    case SET_STATS_TERMINALS_PIE_SELECTED:
      return state.set('statsTerminalsPieSelected', action.data);

    case SET_STATS_TERMINALS_XY_SELECTED:
      return state.set('statsTerminalsXYSelected', action.data);

    case SET_LOGS_GATES:
      return state.set('logsGates', action.data);

    case SET_LOGS_GATES_SELECTED:
      return state.set('logsGatesSelected', action.data);

    case SET_GATES_SORT:
      return state.set('gatesSort', action.sort);

    case SET_LOGS_GATES_ROW_PER_PAGE:
      return state.set('logsGatesRowsPerPage', action.data);

    case SET_LOGS_GATES_CURRENT_PAGE:
      return state.set('logsGatesCurrentPage', action.data);

    case SET_LOGS_GATES_TOTAL:
      return state.set('logsGatesTotal', action.data);

    case SET_LOGS_TERMINALS:
      return state.set('logsTerminals', action.data);

    case SET_LOGS_TERMINALS_SELECTED:
      return state.set('logsTerminalsSelected', action.data);

    case SET_TERMINALS_SORT:
      return state.set('terminalsSort', action.sort);

    case SET_LOGS_TERMINALS_ROW_PER_PAGE:
      return state.set('logsTerminalsRowsPerPage', action.data);

    case SET_LOGS_TERMINALS_CURRENT_PAGE:
      return state.set('logsTerminalsCurrentPage', action.data);

    case SET_LOGS_TERMINALS_TOTAL:
      return state.set('logsTerminalsTotal', action.data);

    case SET_ZONESLIST:
      return state.set('zonesList', action.data);

    case SET_TERMINALSLIST:
      return state.set('terminalsList', action.data);

    case SET_DATETIME:
      return state.set('dateTime', action.data);

    case SET_IS_DATETIME_CHANGE:
      return state.set('isDateTimeChange', action.data);

    case RESET:
      return initialState;

    default:
      return state;
  }
}